import React from "react";
import { Context } from "./Calendar.context.js";
const useCalendarContext = () => React.useContext(Context);
export default useCalendarContext;
